export enum MouseButtons {
    LeftButton = 0,
    MiddleButton = 1,
    RightButton = 2
}
